// Packages and components
import React, { useCallback, useEffect, useState } from 'react';
import { RuleLine, RuleLabel } from './SHDRule.style';
import { Box } from 'grommet';

// Helpers and utlities
import { getComponentClassName } from '@theme/utils/data';

// Types
import type { SHDRuleProps } from './SHDRule.d';

const SHDRule: React.FC<SHDRuleProps> = ({
  className,
  color = 'black-alpha-10',
  direction = 'row',
  label,
  length = 'auto',
  thickness = 1,
}) => {
  // Constants
  const componentClassName = 'rule';
  const ruleThickness =
    typeof thickness === 'number' ? `${thickness}px` : thickness;
  const ruleLength = () => {
    if (length === 'auto') {
      return 'auto';
    }
    if (typeof length === 'number') {
      return `${length}px`;
    }
    return length;
  };

  // States
  const [utilityClassNames, setUtilityClassNames] = useState<string[]>();

  // Handlers
  const handleUtilityClassNameUpdates = useCallback(() => {
    const utilityClassArr: string[] = [];
    if (className) {
      className.split(' ').forEach((name) => {
        utilityClassArr.push(name);
      });
    }
    setUtilityClassNames(utilityClassArr);
  }, [className]);

  // Effects
  useEffect(() => {
    handleUtilityClassNameUpdates();
  }, [handleUtilityClassNameUpdates]);

  // Renderers
  const renderRule = () => {
    return (
      <RuleLine
        className={getComponentClassName(
          `${componentClassName}__line`,
          utilityClassNames
        )}
        direction={direction}
        background={color}
        thickness={ruleThickness}
        length={ruleLength()}
        role="separator"
      />
    );
  };

  const renderFancyRule = () => {
    return (
      <Box
        align="center"
        className={`${componentClassName}`}
        direction={direction}
        fill={direction === 'row' ? 'horizontal' : 'vertical'}
        justify="between"
      >
        <RuleLine
          background={color}
          className={getComponentClassName(
            `${componentClassName}__line`,
            utilityClassNames
          )}
          direction={direction}
          length={ruleLength()}
          thickness={ruleThickness}
          role="separator"
        />
        <RuleLabel color={color} role="heading">
          {label}
        </RuleLabel>
        <RuleLine
          background={color}
          className={getComponentClassName(
            `${componentClassName}__line`,
            utilityClassNames
          )}
          direction={direction}
          length={ruleLength()}
          thickness={ruleThickness}
          role="separator"
        />
      </Box>
    );
  };

  return <>{label ? renderFancyRule() : renderRule()}</>;
};

export default SHDRule;
